export type AdminState = {
  admin: {
    routes: { [key: string]: any };
    isLoading: boolean;
    isError: boolean;
  };
};

export const selectAdminRoutes = (state: AdminState) => state.admin.routes;
